import {
  MOVIE_UPLOAD_NEW, MOVIE_UPLOAD_NEW_SUCCESS, MOVIE_UPLOAD_NEW_FAILURE,
  MOVIE_UPLOAD_RECOMMEND, MOVIE_UPLOAD_RECOMMEND_SUCCESS, MOVIE_UPLOAD_RECOMMEND_FAILURE,
  MOVIE_DELETE_NEW, MOVIE_DELETE_NEW_SUCCESS, MOVIE_DELETE_NEW_FAILURE,
  MOVIE_DELETE_RECOMMEND, MOVIE_DELETE_RECOMMEND_SUCCESS, MOVIE_DELETE_RECOMMEND_FAILURE
} from './mutation-types'

export default {
  state: {
    uploading: false,
    deleting: false
  },
  getters: {
    movieUploading: state => state.uploading,
    movieDeleting: state => state.deleting
  },
  actions: {
    [MOVIE_UPLOAD_NEW] ({ dispatch, commit }, params) {
      commit(MOVIE_UPLOAD_NEW)
      return dispatch('apiPost', {
        url: '/master/movie/new',
        data: params.data,
        isLoading: true
      }).then(res => {
        if (res.status === 200 || res.status === 204) {
          if (res.data.status === 'success') {
            commit(MOVIE_UPLOAD_NEW_SUCCESS)
            if (params.callback) params.callback(res.data)
          } else {
            commit(MOVIE_UPLOAD_NEW_FAILURE, res.data)
          }
        }
        return res
      }).catch(error => {
        commit(MOVIE_UPLOAD_NEW_FAILURE, error)
        throw error
      })
    },
    [MOVIE_UPLOAD_RECOMMEND] ({ dispatch, commit }, params) {
      commit(MOVIE_UPLOAD_RECOMMEND)
      return dispatch('apiPost', {
        url: '/master/movie/recommend',
        data: params.data,
        isLoading: true
      }).then(res => {
        if (res.status === 200 || res.status === 204) {
          if (res.data.status === 'success') {
            commit(MOVIE_UPLOAD_RECOMMEND_SUCCESS)
            if (params.callback) params.callback(res.data)
          } else {
            commit(MOVIE_UPLOAD_RECOMMEND_FAILURE, res.data)
          }
        }
        return res
      }).catch(error => {
        commit(MOVIE_UPLOAD_RECOMMEND_FAILURE, error)
        throw error
      })
    },
    [MOVIE_DELETE_NEW] ({ dispatch, commit }, params) {
      commit(MOVIE_DELETE_NEW)
      return dispatch('apiDelete', {
        url: '/master/movie/new'
      }).then(res => {
        if (res.status === 200 || res.status === 204) {
          if (res.data.status === 'success') {
            commit(MOVIE_DELETE_NEW_SUCCESS)
            if (params.callback) params.callback(res.data)
          } else {
            commit(MOVIE_DELETE_NEW_FAILURE, res.data)
          }
        }
        return res
      }).catch(error => {
        commit(MOVIE_DELETE_NEW_FAILURE, error)
        throw error
      })
    },
    [MOVIE_DELETE_RECOMMEND] ({ dispatch, commit }, params) {
      commit(MOVIE_DELETE_RECOMMEND)
      return dispatch('apiDelete', {
        url: '/master/movie/recommend'
      }).then(res => {
        if (res.status === 200 || res.status === 204) {
          if (res.data.status === 'success') {
            commit(MOVIE_DELETE_RECOMMEND_SUCCESS)
            if (params.callback) params.callback(res.data)
          } else {
            commit(MOVIE_DELETE_RECOMMEND_FAILURE, res.data)
          }
        }
        return res
      }).catch(error => {
        commit(MOVIE_DELETE_RECOMMEND_FAILURE, error)
        throw error
      })
    }
  },
  mutations: {
    [MOVIE_UPLOAD_NEW] (state) {
      state.uploading = true
    },
    [MOVIE_UPLOAD_NEW_SUCCESS] (state) {
      state.uploading = false
    },
    [MOVIE_UPLOAD_NEW_FAILURE] (state) {
      state.uploading = false
    },
    [MOVIE_UPLOAD_RECOMMEND] (state) {
      state.uploading = true
    },
    [MOVIE_UPLOAD_RECOMMEND_SUCCESS] (state) {
      state.uploading = false
    },
    [MOVIE_UPLOAD_RECOMMEND_FAILURE] (state) {
      state.uploading = false
    },
    [MOVIE_DELETE_NEW] (state) {
      state.deleting = true
    },
    [MOVIE_DELETE_NEW_SUCCESS] (state) {
      state.deleting = false
    },
    [MOVIE_DELETE_NEW_FAILURE] (state) {
      state.deleting = false
    },
    [MOVIE_DELETE_RECOMMEND] (state) {
      state.deleting = true
    },
    [MOVIE_DELETE_RECOMMEND_SUCCESS] (state) {
      state.deleting = false
    },
    [MOVIE_DELETE_RECOMMEND_FAILURE] (state) {
      state.deleting = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/movie.js